<template>
    <div>
        <p>
            Nahrajte si vlastný CSV/XML výstup pre import kurzov.<br>
            Pri importe väčšieho množstva kurzov môže import trvať aj niekoľko minút.
        </p>

        <import-results :response="response" :finished="finished"></import-results>

        <form @keydown="submitted = false"
              autocomplete="off"
              class="form-horizontal form-bordered form-row-stripped"
              enctype="multipart/form-data"
        >

            <div v-bind:class="[errors.type ? 'has-error' : '', 'form-group']">
                <div class="col-md-offset-3 col-md-9">
                    <label class="radio-inline" for="file">
                        <input type="radio" value="file" id="file" required="required" v-model="form.type" v-bind:disabled="processing">
                        Súbor
                    </label>
                    <label class="radio-inline" for="url">
                        <input type="radio" value="url" id="url" required="required" v-model="form.type" v-bind:disabled="processing">
                        Url adresa
                    </label>
                    <span class="help-block"
                          v-text="errors.type[0]"
                          v-if="errors.type"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.url ? 'has-error' : '', 'form-group']" v-if="form.type === 'url'">
                <label for="inputUrl" class="control-label col-md-3">Url adresa</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.url ? 'is-invalid' : '', 'form-control']"
                           v-bind:disabled="processing"
                           type="text"
                           @keydown="delete errors.url; submitted = false"
                           id="inputUrl"
                           placeholder="https://"
                           v-model="form.url">
                    <span class="help-block"
                          v-text="errors.url[0]"
                          v-if="errors.url"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.file ? 'has-error' : '', 'form-group']" v-if="form.type === 'file'">
                <label for="inputFile" class="control-label col-md-3">Súbor</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.file ? 'is-invalid' : '', 'form-control']"
                           required
                           type="file"
                           ref="file"
                           @change="fileUpload"
                           id="inputFile">
                    <span class="help-block"
                          v-text="errors.file[0]"
                          v-if="errors.file"
                    ></span>
                </div>
            </div>

            <div class="form-group">
                <div class="col-md-9 col-md-offset-3">
                    <button class="btn btn-primary" v-bind:disabled="processing" @click.prevent="submit">
                        <div v-if="processing">
                            Načítava sa...
                        </div>
                        <div v-else>
                            <span class="glyphicon glyphicon-cloud-upload mr-2"></span>
                            <span>Importovať</span>
                        </div>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import ImportResults from "./ImportResults";

    export default {
        props: ['institution'],

        components: {
            'import-results': ImportResults
        },

        data() {
            return {
                form: {
                    type: 'file',
                    url: null,
                    file: null,
                },
                submitted: false,
                finished: false,
                processing: false,
                errors: {},
                response: {},
                something: null,
            }
        },

        methods: {
            submit() {
                this.submitted = true;
                this.processing = true;
                this.finished = false;

                let formData = new FormData();
                formData.append('type', this.form.type);
                if (this.form.url) {
                    formData.append('url', this.form.url);
                }
                if (this.form.file) {
                    formData.append('file', this.form.file);
                }

                axios.post('/admin/imports/' + this.institution.id + '/upload', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                        this.processing = false;
                        this.finished = true;
                        this.response = response;

                    }).catch(error => {
                        this.processing = false;

                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;

                        } else if (error.response.status === 415) {
                            this.finished = true;
                            this.response = error.response.data;

                        } else if (error.response.status = 504) {
                            this.finished = true;
                            this.response = { error: {
                                message: '504 Gateway Time-out'
                            }};
                        }
                    });
            },

            fileUpload() {
                this.$delete(this.errors, 'file');

                this.submitted = false;

                this.form.file = this.$refs.file.files[0];
            }
        }
    }
</script>

<style scoped>
    input[type=file] {
        border: none;
    }
</style>
